import {intToDirectionEnum} from '@sdox/utils'

import type {DirectionEnum} from '@sdox/utils'
import type {Variants} from 'framer-motion'

type Values = Record<DirectionEnum, string>

const xValues: Values = {
  none: '0%',
  right: '100%',
  left: '-100%',
}

type ConfigurableVariants = (values?: Values) => Variants

export const EnterExitVariants: ConfigurableVariants = (values = xValues) => ({
  enter: (d: number) => ({
    x: values[intToDirectionEnum(d)],
    zIndex: 0,
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
    zIndex: 10,
  },
  exit: (d: number) => ({
    x: values[intToDirectionEnum(d * -1)], //  invert d
    opacity: 0,
    zIndex: 0,
  }),
})
